import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const AddReward = () => {
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [points, setPoints] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [discountValue, setDiscountValue] = useState('');
  const [isExternal, setIsExternal] = useState(false);
  const [externalStore, setExternalStore] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    const rewardData = {
      name,
      description,
      points: parseInt(points, 10),
      expiry_date: expiryDate || null,
      discount_value: parseFloat(discountValue),
      is_external: isExternal ? 1 : 0, // ✅ Ensure integer sent
      external_store: isExternal ? externalStore : null
    };

    console.log('Submitting reward:', rewardData); // ✅ Debug log

    try {
      await axios.post(
        'https://loyaltyprogram.navalsupermart.com/api/rewards.php',
        rewardData
      );
      alert('Reward added successfully!');
      navigate('/rewards');
    } catch (error) {
      alert('Error adding reward');
      console.error(error);
    }
  };

  return (
    <div>
      <h2>Add New Reward</h2>
      <form onSubmit={handleSubmit}>
        <label>Reward Name:</label><br />
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        /><br />

        <label>Description:</label><br />
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
        /><br />

        <label>Points Required:</label><br />
        <input
          type="number"
          value={points}
          onChange={(e) => setPoints(e.target.value)}
          required
        /><br />

        <label>Discount Value:</label><br />
        <input
          type="number"
          step="0.01"
          value={discountValue}
          onChange={(e) => setDiscountValue(e.target.value)}
          required
        /><br />

        <label>Expiry Date:</label><br />
        <input
          type="date"
          value={expiryDate}
          onChange={(e) => setExpiryDate(e.target.value)}
        /><br />

        <label>
          <input
            type="checkbox"
            checked={isExternal}
            onChange={(e) => {
              setIsExternal(e.target.checked);
              if (!e.target.checked) {
                setExternalStore('');
              }
            }}
          />
          Can be claimed externally?
        </label><br />

        {isExternal && (
          <>
            <label>Select External Store:</label><br />
            <select
              value={externalStore}
              onChange={(e) => setExternalStore(e.target.value)}
              required
            >
              <option value="">-- Select Store --</option>
              <option value="Jollibee">Jollibee</option>
              <option value="Mercury Drug">Mercury Drug</option>
              <option value="Lazada">Lazada</option>
            </select><br />
          </>
        )}

        <button type="submit">Add Reward</button>
      </form>
    </div>
  );
};

export default AddReward;